import { getElplanHourValue, groupElplanDraftByHour } from './draft'
import type {
  ElplanDraft,
  ElplanShownReading,
  ElplanSlotFaults,
  ElplanSlotUnit,
  ElplanVolumeReading,
} from './ElplanEditor.types'
import { readElplanVolume } from './volume'

export function getElplanSlotFaults(
  draft: ElplanDraft,
  seed: ElplanDraft,
  typedStarts: ReadonlySet<ISODateTime>
): ElplanSlotFaults {
  const readingByStart: Record<ISODateTime, ElplanVolumeReading> = {}
  const shownReadingByStart: Record<ISODateTime, ElplanShownReading> = {}
  for (const start of draft.slotStarts) {
    const text = draft.textByStart[start]
    const reading = readElplanVolume(text, text === seed.textByStart[start] ? 'any' : 'one')
    readingByStart[start] = reading
    shownReadingByStart[start] = reading.kind === 'fault' && typedStarts.has(start) ? { kind: 'unfinished' } : reading
  }

  return {
    readingByStart,
    shownReadingByStart,
    blocksSave: Object.values(readingByStart).some((reading) => reading.kind !== 'value'),
  }
}

export function getElplanSaveBlockCounts(
  draft: ElplanDraft,
  faults: ElplanSlotFaults,
  mode: ElplanSlotUnit
): { blank: number; invalid: number } {
  const readings =
    mode === 'hour'
      ? groupElplanDraftByHour(draft).map(({ hourStart }) =>
          getElplanHourValue(hourStart, draft, faults.shownReadingByStart)
        )
      : Object.values(faults.shownReadingByStart)
  return {
    blank: readings.filter((reading) => reading.kind === 'blank' || reading.kind === 'partial').length,
    invalid: readings.filter((reading) => reading.kind === 'fault').length,
  }
}
